import {TSKulturart} from './enums/TSKulturart';
import TSAbstractEntity from './TSAbstractEntity';
import {TSSerializable} from './TSSerializable';

export default class TSSchadenObjektDaten extends TSAbstractEntity implements TSSerializable<TSSchadenObjektDaten> {

    private _kulturart: TSKulturart | undefined;

    private _flaecheAre: number | undefined;

    private _holzMenge: number | undefined;

    private _anzahl: number | undefined;

    private _sorte: string | undefined;

    private _alter: number | undefined;

    private _letzteInstandstellung: number | undefined;

    private _laenge: number | undefined;

    private _breite: number | undefined;

    private _hoehe: number | undefined;

    private _bauart: string | undefined;

    private _art: string | undefined;

    private _versicherungVorhanden: boolean | undefined;

    private _versicherungArt: string;

    private _versicherungGemeldet: boolean | undefined;

    public get kulturart(): TSKulturart | undefined {
        return this._kulturart;
    }

    public set kulturart(value: TSKulturart | undefined) {
        this._kulturart = value;
    }

    public get flaecheAre(): number | undefined {
        return this._flaecheAre;
    }

    public set flaecheAre(value: number | undefined) {
        this._flaecheAre = value;
    }

    public get holzMenge(): number | any {
        return this._holzMenge;
    }

    public set holzMenge(value: number | any) {
        this._holzMenge = value;
    }

    public get anzahl(): number | undefined {
        return this._anzahl;
    }

    public set anzahl(value: number | undefined) {
        this._anzahl = value;
    }

    public get sorte(): string | undefined {
        return this._sorte;
    }

    public set sorte(value: string | undefined) {
        this._sorte = value;
    }

    public get alter(): number | undefined {
        return this._alter;
    }

    public set alter(value: number | undefined) {
        this._alter = value;
    }

    public get laenge(): number | undefined {
        return this._laenge;
    }

    public set laenge(value: number | undefined) {
        this._laenge = value;
    }

    public get breite(): number | undefined {
        return this._breite;
    }

    public set breite(value: number | undefined) {
        this._breite = value;
    }

    public get hoehe(): number | undefined {
        return this._hoehe;
    }

    public set hoehe(value: number | undefined) {
        this._hoehe = value;
    }

    public get bauart(): string | undefined {
        return this._bauart;
    }

    public set bauart(value: string | undefined) {
        this._bauart = value;
    }

    public get art(): string | undefined {
        return this._art;
    }

    public set art(value: string | undefined) {
        this._art = value;
    }

    public get versicherungVorhanden(): boolean|undefined {
        return this._versicherungVorhanden;
    }

    public set versicherungVorhanden(value: boolean|undefined) {
        this._versicherungVorhanden = value;
    }

    public get versicherungArt(): string {
        return this._versicherungArt;
    }

    public set versicherungArt(value: string) {
        this._versicherungArt = value;
    }

    public get versicherungGemeldet(): boolean|undefined {
        return this._versicherungGemeldet;
    }

    public set versicherungGemeldet(value: boolean|undefined) {
        this._versicherungGemeldet = value;
    }

    public get letzteInstandstellung(): number | any {
        return this._letzteInstandstellung;
    }

    public set letzteInstandstellung(value: number | any) {
        this._letzteInstandstellung = value;
    }

    deserialize(restObject: any): TSSchadenObjektDaten {
        super.deserialize(restObject);
        this.kulturart = restObject.kulturart;
        this.flaecheAre = restObject.flaecheAre;
        this.anzahl = restObject.anzahl;
        this.sorte = restObject.sorte;
        this.alter = restObject.alter;
        this.letzteInstandstellung = restObject.letzteInstandstellung;
        this.laenge = restObject.laenge;
        this.breite = restObject.breite;
        this.hoehe = restObject.hoehe;
        this.bauart = restObject.bauart;
        this.art = restObject.art;
        this.versicherungVorhanden = restObject.versicherungVorhanden;
        this.versicherungArt = restObject.versicherungArt;
        this.versicherungGemeldet = restObject.versicherungGemeldet;
        this.holzMenge = restObject.holzMenge;

        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);
        restObject.kulturart = this.kulturart;
        restObject.flaecheAre = this.flaecheAre;
        restObject.anzahl = this.anzahl;
        restObject.sorte = this.sorte;
        restObject.alter = this.alter;
        restObject.letzteInstandstellung = this.letzteInstandstellung;
        restObject.laenge = this.laenge;
        restObject.breite = this.breite;
        restObject.hoehe = this.hoehe;
        restObject.bauart = this.bauart;
        restObject.art = this.art;
        restObject.versicherungVorhanden = this.versicherungVorhanden;
        restObject.versicherungArt = this.versicherungArt;
        restObject.versicherungGemeldet = this.versicherungGemeldet;
        restObject.holzMenge = this.holzMenge;

        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSSchadenObjektDaten.ts